import React from 'react'
import { PATHS } from '../../../Config/Routing/paths'
import { getWeekNumberAndYear } from '../../../shared/libraries/utils/date'

import CampaignsIcon from '../../../Assets/Images/icons/campaigns'
import CitiesIcon from '../../../Assets/Images/icons/cities'
import { MISSION_ENUM_TYPES } from '../../../shared/constants'

/**
 * Generates breadcrumbs for the RosterView page that can be consumed by <BreadcrumbsRenderer />
 *
 * @param {object} param.mission Mission's data
 * @param {object} param.match Router's prop
 * @param {boolean} param.fromCityScreen Indicates whether user come to this page from the city screen
 * @param {object} param.city Mission's city
 *
 * @returns {array} Items that can be consumed by <BreadcrumbsRenderer />
 */
export const getBreadcrumbs = ({ mission, city, fromCityScreen }) => {
  const {
    main: { dashboard: root },
    dashboard: { campaigns },
  } = PATHS
  const localDateTime = mission.dateTime
  const { weekNumber, year } = getWeekNumberAndYear(new Date(localDateTime))
  const rosterId = year + '-' + weekNumber

  const hasRoster = mission.type === MISSION_ENUM_TYPES.HANDTOHAND

  const typeSpecificBC = hasRoster
    ? [
        {
          label: city.name,
          link:
            PATHS.main.dashboard +
            PATHS.dashboard.cities +
            `/${city.id}/roster`,
        },
        {
          label: 'View a Roster',
          link: `${root}${campaigns}/${mission.campaign.id}/city-plans/${
            mission.cityPlanId
          }/rosters/${rosterId}`,
        },
      ]
    : [
        {
          label: `${city.name} City Plan`,
          link: `${root}${campaigns}/${mission.campaign.id}/city-plans/${
            mission.cityPlanId
          }/missions`,
        },
      ]

  if (fromCityScreen) {
    return {
      icon: <CitiesIcon style={{ width: 24 }} />,
      items: [
        {
          label: 'Cities',
          link: PATHS.main.dashboard + PATHS.dashboard.cities,
        },
        ...typeSpecificBC,
        { label: 'Mission' },
      ],
    }
  }

  return {
    icon: <CampaignsIcon style={{ width: 16 }} />,
    items: [
      {
        label: 'Campaigns',
        link: `${root}${campaigns}?Status=Active`,
      },
      {
        label: mission.campaign.name,
        link: `${root}${campaigns}/${mission.campaign.id}/city-plans`,
      },
      {
        label: hasRoster ? 'View a Roster' : 'View a City Plan',
        link: `${root}${campaigns}/${mission.campaign.id}/city-plans/${
          mission.cityPlanId
        }${hasRoster ? '/rosters/' + rosterId : '/missions'}`,
      },
      {
        label: 'Mission',
      },
    ],
  }
}
